import { homeImages, productImages, studioImages } from './images';
import type { Recognition } from './types';

export const studio = {
  name: 'Silvana Barbato',
  role: { it: 'Interior Designer', en: 'Interior Designer' },
  founded: '2015',
  city: 'Varese',
  address: 'Via San Martino 12, 21100 Varese',
  // PLACEHOLDER — sostituire con la P.IVA reale di Silvana prima del go-live.
  vat: '03210980124',
  email: 'studioateliervarese@gmail.com',
  phone: '+39 347 5338631',
  phoneHref: '+393475338631',
  whatsapp: 'https://wa.me/393475338631',
  instagram: 'https://www.instagram.com/',
  /** Real photos of Silvana from her site. */
  portrait: '/images/studio/1e3fb2_869681d0ceb7425cbf925cec4488467b.jpg', // B&W headshot
  atelier: '/images/studio/1e3fb2_5ac9660d212047daab838d5b0da0b667.jpg', // Silvana in her atelier (she stands to the right)
  studioImages,
  /** SATURNO — the signature lamp shown at Dubai Design Week. */
  saturno: '/images/home/1e3fb2_baffc8818ecf4841913811fc3b1d2ed6.jpg',
  productImages,
  homeImages,
};

export const recognitions: Recognition[] = [
  {
    year: '1999',
    title: 'Politecnico di Milano',
    detail: 'Laurea in Disegno Industriale, Facoltà di Architettura.',
    detailEn: 'Degree in Industrial Design, Faculty of Architecture.',
  },
  {
    year: '2005',
    title: 'Studio a Milano',
    titleEn: 'Studio in Milan',
    detail: 'Apre il proprio studio di progettazione con l’Arch. Ferlazzo Natoli.',
    detailEn: 'Opens her own design studio with Arch. Ferlazzo Natoli.',
  },
  {
    year: '2013',
    title: 'Alta Formazione HO.RE.CA',
    titleEn: 'HO.RE.CA Advanced Course',
    detail: 'Al Politecnico di Milano, dedicata a ristorazione, hôtellerie ed entertainment.',
    detailEn: 'At Politecnico di Milano, on dining, hospitality and entertainment.',
  },
  {
    year: '2015',
    title: 'Studio Atelier · Varese',
    detail: 'Fonda lo studio nel centro storico e cofonda Varese Design Week.',
    detailEn: 'Founds the studio in the old town and co-founds Varese Design Week.',
  },
  {
    year: '2024',
    title: 'ARCH & SATURNO',
    detail: 'ARCH a Marmomac (Domus, ElleDecor, IoArch); SATURNO su 1stDibs e Pamono.',
    detailEn: 'ARCH at Marmomac (Domus, ElleDecor, IoArch); SATURNO on 1stDibs and Pamono.',
  },
];
